var _rect, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChordShiftButtonMember(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 5,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_563_1833)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 12.4086V14.7639L12.381 14.3266V17H11.3961V14.1622L7.03106 13.434V17H6.04623V13.2696L3 12.7615V10.4062L6.0448 10.9144V7.64083L3 7.13269V4.77744L6.0448 5.28558V1.99849H7.02963V5.44843L11.3947 6.17672V1.99849H12.3795V6.34107L14.9986 6.77835V9.13359L12.3795 8.69632V11.9698L14.9986 12.4071L15 12.4086ZM11.3961 8.53347L7.03106 7.80519V11.0787L11.3961 11.807V8.53347Z",
    fill: "#5C5C5C"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_563_1833)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.0813 17.5786C22.7297 17.5786 21.0236 19.5992 21.0236 19.5992L21.0621 4H20V27C25.9912 27 28 21.8889 28 20.8206C28 19.7522 27.4313 17.5786 25.0797 17.5786H25.0813ZM24.0008 24.8903C21.9385 26.1857 20.9584 25.7634 20.9584 25.7634V21.6264C22.9655 18.7849 24.6515 19.4578 25.4443 20.2553C26.2371 21.0527 26.0631 23.5948 24.0025 24.892L24.0008 24.8903Z",
    fill: "#5C5C5C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChordShiftButtonMember);
export default __webpack_public_path__ + "static/media/chord-shift-button-member.8d104b21fa0b6a761219b8aa5d09bd78.svg";
export { ForwardRef as ReactComponent };